import styled from 'styled-components'

export const InformationContent = styled.div`
  padding: 0;
  width: 100%;

  --primary: #00ade6;
  --primary-light: #e6f7fc;
  --primary-hover: #00a1d6;
  --text-primary: #1a1a1a;
  --text-secondary: #6b6b6b;
  --text-tertiary: #999999;
  --bg-primary: #ffffff;
  --bg-secondary: #fafafa;
  --bg-tertiary: #f5f5f5;
  --border: #e5e5e5;
  --border-light: #f0f0f0;
  --success: #00b341;
  --warning: #ff9500;
  --danger: #ff3b30;
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.04);
  --shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    padding: 0;
  }

  @media (max-width: 480px) {
    padding: 0;

    .property-grid,
    .expandable-details,
    .owner-details {
      grid-template-columns: 1fr;
    }

    .section-content {
      padding: 16px;
    }
  }
`
